// extracted by mini-css-extract-plugin
module.exports = {"item":"creatableItem_item__abv9N","icon":"creatableItem_icon__4PMRG"};